import { Autocomplete, Box, Chip, FormControl, IconButton, InputAdornment, InputLabel, MenuItem, OutlinedInput, Select, TextField } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import LoaderComp from '../../newComponent/LoaderComp/Loader';
import CustomSnackbar from '../../components/ui-component/snackbar/CustomSnackbar';
import { useNavigate } from 'react-router-dom';

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
const performanceKey = process.env.REACT_APP_PERFORMANCE_API_KEY;


function DetailedRevenueReportPage() {
    const navigate = useNavigate()
    const [isLoading, setIsLoading] = useState(false);
    const [selectedButton, setSelectedButton] = useState("revenue");
    const [selectedChip, setSelectedChip] = useState(0);
    const [countries, setCountries] = useState([])
    const [quarters, setQuarters] = useState([])
    const [months, setMonths] = useState([])
    const [advisors, setAdvisors] = useState([])
    const [branches, setBranches] = useState([])
    const [products, setProducts] = useState([])
    const [selectedCountry, setSelectedCountry] = useState(101);
    const [selectedDuration, setSelectedDuration] = useState("monthly")
    const [selectedMonth, setSelectedMonth] = useState(null);
    const [selectedQuarter, setSelectedQuarter] = useState(null);
    const currentYear = new Date().getFullYear();
     const [selectedYear, setSelectedYear] = useState(currentYear);
    const lastFiveYears = Array.from({ length: 5 }, (_, i) => currentYear - i);
    const [snackbarOpen, setSnackbarOpen] = React.useState(false);
      const [snackbarMessage, setSnackbarMessage] = React.useState("");
      const [snackbarSeverity, setSnackbarSeverity] = React.useState("success");
      const [tableData, setTableData] = useState([])
      const [advisorData, setAdvisorData] = useState([])
      const [branchData, setBranchData] = useState([])
      const [productData, setProductData] = useState([])
      const [highestPerformer, setHighestPerformer] = useState(null);
      const [lowestPerformer, setLowestPerformer] = useState(null);
      const [showFilter, setShowFilter] = useState(false);
      const [selectedAdvisors, setSelectedAdvisors] = useState([])
      const [selectedBranches, setSelectedBranches] = useState([])
      const [selectedProducts, setSelectedProducts] = useState([])
    
      const showSnackbar = (message, severity) => {
        setSnackbarMessage(message);
        setSnackbarSeverity(severity);
        setSnackbarOpen(true);
      };

  const handleChange = (event) => {
    setSelectedCountry(event.target.value);
    setSelectedAdvisors([]);
    setSelectedBranches([]);
  };

  const handleDurationChange = (event) => {
    setSelectedDuration(event.target.value);
    setSelectedMonth(null)
    setSelectedQuarter(null)
  };

  const handleYearChange = (e) => {
    setSelectedYear(e.target.value);
  };

  const handleShowFilter = () => {
    setShowFilter(!showFilter)
  }

  const chips = ['Advisor Wise', 'Branch Wise', 'Product Wise'];

  const buttonStyle = (id) => ({
    width: '281px',
    height: '50px',
    borderRadius: '7px',
    border: '1px solid #EEEEEE',
    background: selectedButton === id ? '#2E7D3214' : '#FFFFFF14',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '0 16px',
    cursor: 'pointer',
    fontFamily: 'Inter, sans-serif',
  });

  const textStyle = (id) => ({
    fontWeight: 600,
    fontSize: '18px',
    lineHeight: '100%',
    color: selectedButton === id ? '#388E3C' : '#000',
  });

  const iconStyle = (id) => ({
    width: '20px',
    height: '20px',
    //filter: selectedButton === id ? 'brightness(0) saturate(100%) sepia(20%) hue-rotate(60deg) brightness(90%) contrast(100%)' : 'none',
  });

  const baseChipStyle = {
  cursor: 'pointer',
  height: '34px',
  borderRadius: '24px',
  border: '1px solid #EEEEEE',
  padding: '0 24px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '14px',
  fontWeight: 600,
  fontFamily: 'Inter, sans-serif',
  whiteSpace: 'nowrap',
  transition: 'all 0.2s ease-in-out',
};

const getButtonStyle = (bgColor, textColor) => ({
  //width: '184px',
  minWidth: '184px',
  height: '40px',
  borderRadius: '8px',
  border: '1px solid #EEEEEE',
  backgroundColor: bgColor,
  fontFamily: 'Inter, sans-serif',
  fontWeight: 600,
  fontSize: '16px',
  lineHeight: '100%',
  color: textColor,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '0 16px',
  cursor: 'pointer',
  gap: '8px',
});

const dropdownContainerStyle = {
  width: '153px',
  height: '38px',
  borderRadius: '8px',
  border: '1px solid #EEEEEE',
  backgroundColor: '#fff',
  boxShadow: '0px 0px 10px 0px #0000000D',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '0 12px',
  cursor: 'pointer',
};

const dropdownSelectStyle = {
  border: 'none',
  outline: 'none',
  background: 'transparent',
  fontSize: '14px',
  fontFamily: 'Inter, sans-serif',
  fontWeight: 500,
  width: '100%',
  appearance: 'none',
  color: '#000',
  WebkitAppearance: 'none',
  MozAppearance: 'none',
};

const applyButtonStyle = {
  width: '136px',
  height: '36px',
  borderRadius: '20px',
  border: 'none',
  fontFamily: 'Poppins, sans-serif',
  fontWeight: 600,
  fontSize: '18px',
  lineHeight: '100%',
  color: '#fff',
  cursor: 'pointer',
};

const cellStyle = {
  border: '1px solid #BDB9B9',
  padding: '12px',
  textAlign: 'center',
  verticalAlign: 'middle',
  fontFamily: 'Inter, sans-serif',
  fontWeight: 600,
  fontSize: '14px',
  lineHeight: '100%',
  letterSpacing: '0px',
};

const targetChipStyle = {
  display: 'inline-block',
  borderRadius: '22px',
  padding: '6px 20px',
  gap: '10px',
  backgroundColor: '#E651001A', 
  color: '#E65100',            
  fontFamily: 'Inter, sans-serif',
  fontWeight: 600,
  fontSize: '14px',
  lineHeight: '100%',
  textAlign: 'center',
};

const achievedChipStyle = {
  display: 'inline-block',
  borderRadius: '22px',
  padding: '6px 20px',
  gap: '10px',
  backgroundColor: '#2E7D321A', 
  color: '#2E7D32',         
  fontFamily: 'Inter, sans-serif',
  fontWeight: 600,
  fontSize: '14px',
  lineHeight: '100%',
  textAlign: 'center',
};

const dropdownContainerStyle2 = {
  position: 'relative',
  display: 'inline-block',
  width: '153px',
};

const dropdownSelectStyle2 = {
  width: '100%',
  minHeight: '38px',
  borderRadius: '8px',
  border: '1px solid #EEEEEE',
  backgroundColor: '#fff',
  boxShadow: '0px 0px 10px 0px #0000000D',
  fontFamily: 'Inter, sans-serif',
  fontWeight: 500,
  fontSize: '14px',
  padding: '8px 12px',
  paddingRight: '30px',
  appearance: 'none', // removes native dropdown arrow
  cursor: 'pointer',
};

const dropdownArrowStyle = {
  position: 'absolute',
  right: '10px',
  top: '50%',
  transform: 'translateY(-50%)',
  width: '14px',
  height: '8px',
  pointerEvents: 'none',
};

const AdvisorTable = ({ data }) => {
  return (
    <table style={{ borderCollapse: 'collapse', width: '100%' }}>
      <tbody>
        {data?.response?.length > 0 ? (
          <>
            {data.response.map((branch, branchIndex) => (
              <React.Fragment key={branchIndex}>
                {/* Branch Header */}
                <tr>
                  <th colSpan={9} style={{
                    ...cellStyle,
                    background: '#F9F9F966',
                    color: '#37A33C',
                    fontWeight: 600,
                    fontSize: '20px',
                    lineHeight: '100%',
                  }}>
                    {branch.branch_id.branch_name}
                  </th>
                </tr>

                {/* Table Header */}
                <tr>
                  <th style={cellStyle}>Advisor Name</th>
                  <th style={cellStyle}>Metrics</th>
                  {branch.user[0]?.product.map((p, i) => (
                    <th key={i} style={cellStyle}>{p.name}</th>
                  ))} 
                </tr>

                {/* Advisor Data */}
                {branch.user.map((advisor, advisorIndex) => {
                  return (
                    <React.Fragment key={advisorIndex}>
                      {/* Target Row */}
                      <tr>
                        <td style={cellStyle} rowSpan={2}>
                          {advisor.first_name} {advisor.last_name ?? ''}
                        </td>
                        <td style={cellStyle}><span style={targetChipStyle}>Target</span></td>
                        {advisor.product.map((p, i) => (
                          <td key={i} style={cellStyle}>{p.target}</td>
                        ))}
                      </tr>

                      {/* Achieved Row */}
                      <tr>
                        <td style={cellStyle}><span style={achievedChipStyle}>Achieved</span></td>
                        {advisor.product.map((p, i) => (
                          <td key={i} style={cellStyle}>
                            {p.achived}{' '}
                            <span style={{ color: p.per >= 50 ? '#07990F' : '#E92E32' }}>
                              ({p.per?.toFixed(0)}%)
                            </span>
                          </td>
                        ))}
                      </tr>
                    </React.Fragment>
                  );
                })}
              </React.Fragment>
            ))}

            {/* Grand Total Section - Appears only once at the end */}
            <tr>
              <th colSpan={9} style={{
                ...cellStyle,
                background: '#E6F4EA8A',
                color: '#37A33C',
                fontWeight: 600,
                fontSize: '20px',
                lineHeight: '100%',
              }}>
                Grand Revenue Total
              </th>
            </tr>

             <tr>
                  <th style={cellStyle}></th>
                  <th style={cellStyle}>Metrics</th>
                  {data?.grand_total?.map((p, i) => (
                <td key={i} style={cellStyle}>{p.name}</td>
              ))}
                </tr>
            <tr>
              <td style={cellStyle} rowSpan={2}><strong>Grand Total</strong></td>
              <td style={cellStyle}><span style={targetChipStyle}>Target</span></td>
              {data.grand_total.map((p, i) => (
                <td key={i} style={cellStyle}>{p.target}</td>
              ))}
            </tr>

            <tr>
              <td style={cellStyle}><span style={achievedChipStyle}>Achieved</span></td>
              {data.grand_total.map((p, i) => (
                <td key={i} style={cellStyle}>
                  {p.achived}{' '}
                  <span style={{ color: p.per >= 50 ? '#07990F' : '#E92E32' }}>
                    ({p.per.toFixed(0)}%)
                  </span>
                </td>
              ))}
            </tr>
          </>
        ) : (
          <tr>
            <td colSpan={9} style={{
              textAlign: 'center',
              padding: '20px',
              fontStyle: 'italic',
              color: '#999',
              fontFamily: 'Inter, sans-serif',
              fontWeight: 600,
              fontSize: '14px'
            }}>
              No advisor data available
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

const BranchTable = ({ data }) => {
  return (
    <table style={{ borderCollapse: 'collapse', width: '100%' }}>
      <tbody>
        {data?.response?.length > 0 ? (
          <>
            {data.response.map((branch, branchIndex) => {
          return (
            <React.Fragment key={branchIndex}>
              {/* Branch Header */}
              <tr>
                <th colSpan={8} style={{
                  ...cellStyle,
                  background: '#F9F9F966',
                  color: '#37A33C',
                  fontWeight: 600,
                  fontSize: '20px',
                  lineHeight: '100%',
                }}>
                  {branch.branch_name}
                </th>
              </tr>

              {/* Table Header */}
              <tr>
                <th style={cellStyle}>Metrics</th>
                {branch.product.map((p, i) => (
                  <th key={i} style={cellStyle}>{p.name}</th>
                ))}
              </tr>

              {/* Target Row */}
              <tr>
                <td style={cellStyle}><span style={targetChipStyle}>Target</span></td>
                {branch.product.map((p, i) => (
                  <td key={i} style={cellStyle}>{p.target}</td>
                ))}
              </tr>

              {/* Achieved Row */}
              <tr>
                <td style={cellStyle}><span style={achievedChipStyle}>Achieved</span></td>
                {branch.product.map((p, i) => (
                  <td key={i} style={cellStyle}>
                    {p.achived}{' '}
                    <span style={{ color: p.per >= 50 ? '#07990F' : '#E92E32' }}>
                      ({p.per?.toFixed(0)}%)
                    </span>
                  </td>
                ))}
              </tr>
            </React.Fragment>
          );
        })}


            {/* Grand Total Section - Appears only once at the end */}
            <tr>
              <th colSpan={8} style={{
                ...cellStyle,
                background: '#E6F4EA8A',
                color: '#37A33C',
                fontWeight: 600,
                fontSize: '20px',
                lineHeight: '100%',
              }}>
                Grand Revenue Total
              </th>
            </tr>

             <tr>
                  <th style={cellStyle}>Metrics</th>
                  {data?.grand_total?.map((p, i) => (
                <td key={i} style={cellStyle}>{p.name}</td>
              ))}
                </tr>
            <tr>
              <td style={cellStyle}><span style={targetChipStyle}>Target</span></td>
              {data.grand_total.map((p, i) => (
                <td key={i} style={cellStyle}>{p.target}</td>
              ))}
            </tr>

            <tr>
              <td style={cellStyle}><span style={achievedChipStyle}>Achieved</span></td>
              {data.grand_total.map((p, i) => (
                <td key={i} style={cellStyle}>
                  {p.achived}{' '}
                  <span style={{ color: p.per >= 50 ? '#07990F' : '#E92E32' }}>
                    ({p.per.toFixed(0)}%)
                  </span>
                </td>
              ))}
            </tr>
          </>
        ) : (
          <tr>
            <td colSpan={9} style={{
              textAlign: 'center',
              padding: '20px',
              fontStyle: 'italic',
              color: '#999',
              fontFamily: 'Inter, sans-serif',
              fontWeight: 600,
              fontSize: '14px'
            }}>
              No branch data available
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

const ProductTable = ({ data }) => {
  return (
    <table style={{ borderCollapse: 'collapse', width: '100%' }}>
  <tbody>
    {data?.response?.length > 0 ? (
      <>
        {/* Branch Header */}
        <tr>
          <th
            colSpan={3}
            style={{
                  ...cellStyle,
                  background: '#F9F9F966',
                  color: '#37A33C',
                  fontWeight: 600,
                  fontSize: '20px',
                  lineHeight: '100%',
                }}
          >
            Product Report
          </th>
        </tr>

        {/* Table Header */}
        <tr>
          <th style={cellStyle}>Metrics</th>
          <th style={cellStyle}>
            <span style={targetChipStyle}>Target</span>
          </th>
          <th style={cellStyle}>
            <span style={achievedChipStyle}>Achieved</span>
          </th>
        </tr>

        {/* Product Data Rows */}
        {data.response.map((product, index) => (
          <tr key={index}>
            <td style={cellStyle}>{product.name}</td>
            <td style={cellStyle}>{product.target || 0}</td>
            <td style={cellStyle}>
                  {product.achived}{' '}
                  <span style={{ color: product.per >= 50 ? '#07990F' : '#E92E32' }}>
                    ({product.per.toFixed(0)}%)
                  </span>
                </td>
          </tr>
        ))}
      </>
    ) : (
      <tr>
        <td
          colSpan={3}
          style={{
            textAlign: 'center',
            padding: '20px',
            fontStyle: 'italic',
            color: '#999',
            fontFamily: 'Inter, sans-serif',
            fontWeight: 600,
            fontSize: '14px',
          }}
        >
          No product data available
        </td>
      </tr>
    )}
  </tbody>
</table>

  );
};

  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}country`)
      .then(response => response.json())
      .then(data => {
        let filteredData = data.filter((item) => item.id == 101 || item.id == 153)
        setCountries(filteredData);
    })
    .catch(error => {
      console.error('Error fetching countries:', error);
    });
    }, [])

    useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}month`)
      .then(response => response.json())
      .then(data => {
        setMonths(data);
      const currentMonthNumber = new Date().getMonth() + 1; 
      const matchedMonth = data.find(
        (month) => Number(month.id) === currentMonthNumber
      );

      if (matchedMonth) {
        setSelectedMonth(matchedMonth.id);
      }
    })
    .catch(error => {
      console.error('Error fetching months:', error);
    });
    }, [])

    useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}quarter`)
      .then(response => response.json())
      .then(data => {
        setQuarters(data);
    })
    .catch(error => {
      console.error('Error fetching countries:', error);
    });
    }, [])

    useEffect(() => {
      if (!selectedCountry) return;

      const fetchData = async () => {
        const response = await fetch(`${API_ENDPOINT}route/advisorby-country`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({country_id: selectedCountry})
        });
        if (response.ok) {
          const data = await response.json();
          setAdvisors(data)
        }  else {
          setAdvisors([])
        }
    };

    fetchData();
    }, [selectedCountry])

    useEffect(() => {
    // Fetch menu items using the fetch function
    if(!selectedCountry) return;

    fetch(`${API_ENDPOINT}branch`)
      .then(response => response.json())
      .then(data => {
        let filteredData = data.filter((item) => item.country_id == selectedCountry)
        setBranches(filteredData);
    })
    .catch(error => {
      console.error('Error fetching countries:', error);
    });
    }, [selectedCountry])

    useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}product`)
      .then(response => response.json())
      .then(data => {
        setProducts(data);
    })
    .catch(error => {
      console.error('Error fetching products:', error);
    });
    }, [])

    const allFiltersSelected =
      selectedDuration &&
      selectedYear &&
      (
        (selectedDuration === "monthly" && selectedMonth) ||
        (selectedDuration === "quarterly" && selectedQuarter) ||
        (selectedDuration === "yearly")
      );

    useEffect(() => {
      if (!selectedMonth) return;

        const fetchData = async () => {
          let route;

          if (selectedButton === "revenue" && selectedChip === 0)
            route = `${API_ENDPOINT}route/performance-advisor-revenue-report`;

          if (selectedButton === "enrolment" && selectedChip === 0)
            route = `${API_ENDPOINT}route/performance-advisor-enrolment-report`;

          if (selectedButton === "revenue" && selectedChip === 1)
            route = `${API_ENDPOINT}route/performance-branch-revenue-report`;

          if (selectedButton === "enrolment" && selectedChip === 1)
            route = `${API_ENDPOINT}route/performance-branch-enrolment-report`;

          if (selectedButton === "revenue" && selectedChip === 2)
            route = `${API_ENDPOINT}route/performance-product-revenue-report`;

          if (selectedButton === "enrolment" && selectedChip === 2)
            route = `${API_ENDPOINT}route/performance-product-enrolment-report`;

          let requestData = {
              country_id: selectedCountry,
              duration: selectedDuration,
              month_quarter:
                selectedDuration === "yearly"
                  ? null
                  : selectedDuration === "quarterly"
                  ? selectedQuarter
                  : selectedMonth,
              year: selectedYear,
          };


         if (selectedChip === 0) {
                requestData = {
                  ...requestData,
                  advisor_user_id: selectedAdvisors
                };
          }

          if (selectedChip === 1) {
                requestData = {
                  ...requestData,
                  branch_id: selectedBranches
                };
          }

          if (selectedChip === 2) {
                requestData = {
                  ...requestData,
                  product_id: selectedProducts
                };
          }
          setIsLoading(true);

      let headers = {
          "per-api-key": `${performanceKey}`,
         "Content-Type": "application/json" 
    };
          try {
          const response = await fetch(route, {
            method: "POST",
            headers,
            body: JSON.stringify(requestData),
          });

          const result = await response.json(); 

          if (response.ok) {
            setTableData(result);

            if (selectedChip === 0) setAdvisorData(result);
            if (selectedChip === 1) setBranchData(result);
            if (selectedChip === 2) setProductData(result);

            setHighestPerformer(result?.highest_performer);
            setLowestPerformer(result?.lowest_performer);
          } else {
            showSnackbar(result.message || "Something went wrong", "error");
          }
        } catch (error) {
          console.error("Fetch error:", error);
          showSnackbar("An error occurred while fetching data", "error");
        } finally {
          setIsLoading(false);
        }
      }
        fetchData();
    }, [selectedButton, selectedChip, selectedMonth]);


    const handleApplyFilter = async () => {
    if (selectedDuration === "monthly" && selectedMonth === null) {
      showSnackbar("Please Select Month", "error");
      return;
    }

    if (selectedDuration === "quarterly" && selectedQuarter === null) {
      showSnackbar("Please Select Quarter", "error");
      return;
    }

    if (selectedYear === null) {
      showSnackbar("Please Select Year", "error");
      return;
    }

    if (selectedCountry === null) {
      showSnackbar("Please Select Country", "error");
      return;
    }

    let route;

    if (selectedButton === "revenue" && selectedChip === 0)
      route = `${API_ENDPOINT}route/performance-advisor-revenue-report`;

    if (selectedButton === "enrolment" && selectedChip === 0)
      route = `${API_ENDPOINT}route/performance-advisor-enrolment-report`;

    if (selectedButton === "revenue" && selectedChip === 1)
      route = `${API_ENDPOINT}route/performance-branch-revenue-report`;

    if (selectedButton === "enrolment" && selectedChip === 1)
      route = `${API_ENDPOINT}route/performance-branch-enrolment-report`;

    if (selectedButton === "revenue" && selectedChip === 2)
      route = `${API_ENDPOINT}route/performance-product-revenue-report`;

    if (selectedButton === "enrolment" && selectedChip === 2)
      route = `${API_ENDPOINT}route/performance-product-enrolment-report`;

      let requestData = {
              country_id: selectedCountry,
              duration: selectedDuration,
              month_quarter:
                selectedDuration === "yearly"
                  ? null
                  : selectedDuration === "quarterly"
                  ? selectedQuarter
                  : selectedMonth,
              year: selectedYear,
      };

    if (selectedChip === 0) {
                requestData = {
                  ...requestData,
                  advisor_user_id: selectedAdvisors
                };
          }

          if (selectedChip === 1) {
                requestData = {
                  ...requestData,
                  branch_id: selectedBranches
                };
          }

          if (selectedChip === 2) {
                requestData = {
                  ...requestData,
                  product_id: selectedProducts
                };
          }

    setIsLoading(true);

    try {
       let headers = {
      "per-api-key":  `${performanceKey}`,
      "Content-Type": "application/json" 
    };
      const response = await fetch(route,
        {
          method: "POST",
          headers ,
          body: JSON.stringify(requestData),
        }
      );

      const result = await response.json(); 

      if (response.ok) {
        setTableData(result);
        if(selectedChip === 0) setAdvisorData(result);
        if(selectedChip === 1) setBranchData(result);
        if(selectedChip === 2) setProductData(result);
        setHighestPerformer(result?.highest_performer)
        setLowestPerformer(result?.lowest_performer)
        setIsLoading(false);
      } else {
         showSnackbar(result.message || "Something went wrong", "error");
      }
    } catch (error) {
      showSnackbar("An error occurred while fetching data", "error");
    }
  };

  return (
    <div style={{ padding: '20px', fontFamily: 'Inter, sans-serif', position: 'relative' }}>
       <LoaderComp isLoading={isLoading} />
      <header style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
        <img 
          src="/reportpage/stmlogo.png" 
          alt="Logo" 
          style={{ height: '30px' }}
        />
      </header>

      {/* "Dear Siecians" Title */}
      <div style={{ textAlign: 'center', marginBottom: '10px' }}>
        <div
          style={{
            fontWeight: 700,
            fontSize: '22px',
            lineHeight: '100%',
            color: '#2E7D32',
            display: 'inline-block',
            padding: '8px 16px',
            borderRadius: '4px',
          }}
        >
          Dear Siecians,
        </div>
      </div>

      {/* "Performance Report Dashboard" Subtitle */}
      <div style={{ textAlign: 'center', marginBottom: '10px' }}>
        <div
          style={{
            fontWeight: 600,
            fontSize: '22px',
            lineHeight: '100%',
            color: '#000',
            display: 'inline-block',
          }}
        >
          Performance Report Dashboard
        </div>
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '24px', marginRight: "10px" }}>
          <div style={{ display: 'flex', gap: '12px' }}>
             <button
          onClick={() => setSelectedButton('revenue')}
          style={buttonStyle('revenue')}
        >
          <img
            src="/reportpage/money-bag 1.png"
            alt="Revenue"
            style={iconStyle('revenue')}
          />
          <span style={textStyle('revenue')}>Revenue Report</span>
        </button>

        {/* Button 2 */}
        <button
          onClick={() => setSelectedButton('enrolment')}
          style={buttonStyle('enrolment')}
        >
          <img
            src="/reportpage/document 1.png"
            alt="Enrolment"
            style={iconStyle('enrolment')}
          />
          <span style={textStyle('enrolment')}>Enrolment Report</span>
        </button>
          </div>

          <div style={{ display: 'flex', gap: '16px' }}>
            <button
              style={{
                width: '79px',
                height: '24px',
                backgroundColor: 'transparent',
                border: 'none',
                padding: 0,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              onClick={handleShowFilter}
            >
              <img
                src="/reportpage/filter.png"
                alt="Icon"
                style={{ maxWidth: '100%', maxHeight: '100%' }}
              />
            </button>
          </div>
      </div>

      <div
      style={{
        maxWidth: '100%',
        minHeight: '100vh',
        margin: '24px',
        backgroundColor: '#fff',
        color: '#000',
        borderRadius: '6px',
        padding: '24px',
        boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
        boxSizing: 'border-box',
      }}
    >
        {/* Chips and Buttons Container */}
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '24px' }}>
        {/* Chips */}
        <div style={{ display: 'flex', gap: '12px' }}>
          {chips.map((label, index) => {
            const isSelected = selectedChip === index;
            return (
              <div
                key={index}
                onClick={() => setSelectedChip(index)}
                style={{
                  ...baseChipStyle,
                  backgroundColor: isSelected ? '#007BFF1A' : '#fff',
                  color: isSelected ? '#007BFF' : '#000',
                }}
              >
                {label}
              </div>
            );
          })}
        </div>

        {/* Buttons */}
        <div style={{ display: 'flex', gap: '16px' }}>
        {highestPerformer && (
          <button style={getButtonStyle('#2E7D321A','#2E7D32')}>
            {highestPerformer}
            <div style={{ display: 'flex', alignItems: 'center', gap: '2px', marginLeft: '8px' }}>
              <img
                src="/reportpage/greenarrow.png"
                alt="Short Arrow"
                style={{ width: '12px', height: '24px' }}
              />
              <img
                src="/reportpage/greenarrow.png"
                alt="Long Arrow"
                style={{ width: '10px', height: '18px' }}
              />
            </div>
          </button>
        )}
        
        {lowestPerformer && (
          <button style={getButtonStyle('#E610141A', '#E61014')}>
           {lowestPerformer}
            <div style={{ display: 'flex', alignItems: 'center', gap: '2px', marginLeft: '8px' }}>
              <img
                src="/reportpage/redarrow.png"
                alt="Short Arrow"
                style={{ width: '12px', height: '24px' }}
              />
              <img
                src="/reportpage/redarrow.png"
                alt="Long Arrow"
                style={{ width: '10px', height: '18px' }}
              />
            </div>
          </button>
        )}
        </div>
      </div>

{showFilter && (
  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '24px' }}>
  {/* Dropdown */}
  <div style={{ display: 'flex', gap: '16px' }}>
    <div style={dropdownContainerStyle}>
      <select  
        style={dropdownSelectStyle} 
        defaultValue=""
        value={selectedCountry}
        onChange={handleChange}
        >
        <option value="" disabled hidden>
          Select Country
        </option>
        {countries.map((country) => (
          <option key={country.id} value={country.id}>{country.country_name}</option>
        ))}
      </select>
      <img
        src="/reportpage/arrowdropdown.png"
        alt="Down arrow"
        style={{ width: '14px', height: '8px', pointerEvents: 'none' }}
      />
    </div>

    
    <div style={dropdownContainerStyle}>
      <select 
        style={dropdownSelectStyle} 
        defaultValue=""
        value={selectedDuration}
        onChange={handleDurationChange}
        >
        <option value="" disabled hidden>
          Select Duration
        </option>
        <option value="monthly">Monthly</option>
        <option value="quarterly">Quarterly</option>
        <option value="yearly">Yearly</option>
      </select>
     <img
        src="/reportpage/arrowdropdown.png"
        alt="Down arrow"
        style={{ width: '14px', height: '8px', pointerEvents: 'none' }}
      />
    </div>

    {selectedDuration == "monthly" && (
      <div style={dropdownContainerStyle}>
      <select  
        style={dropdownSelectStyle} 
        defaultValue=""
        value={selectedMonth}
        onChange={(event) => setSelectedMonth(event.target.value)}
        >
        <option value="" disabled hidden>
          Select Month
        </option>
        {months.map((month) => (
          <option key={month.id} value={month.id}>{month.month_full_name}</option>
        ))}
      </select>
      <img
        src="/reportpage/arrowdropdown.png"
        alt="Down arrow"
        style={{ width: '14px', height: '8px', pointerEvents: 'none' }}
      />
    </div>
    )}

    {selectedDuration == "quarterly" && (
      <div style={dropdownContainerStyle}>
      <select  
        style={dropdownSelectStyle} 
        defaultValue=""
        value={selectedQuarter}
        onChange={(event) => setSelectedQuarter(event.target.value)}
        >
        <option value="" disabled hidden>
          Select Quarter
        </option>
        {quarters.map((item) => (
          <option key={item.id} value={item.id}>{item.quarter_sort_name}</option>
        ))}
      </select>
      <img
        src="/reportpage/arrowdropdown.png"
        alt="Down arrow"
        style={{ width: '14px', height: '8px', pointerEvents: 'none' }}
      />
    </div>
    )}

    {/* Year Dropdown */}
      <div style={dropdownContainerStyle}>
        <select
          style={dropdownSelectStyle}
          value={selectedYear}
          onChange={handleYearChange}
        >
          <option value="" disabled hidden>
            Select Year
          </option>
          {lastFiveYears.map((year) => (
            <option key={year} value={year}>{year}</option>
          ))}
        </select>
        <img
        src="/reportpage/arrowdropdown.png"
        alt="Down arrow"
        style={{ width: '14px', height: '8px', pointerEvents: 'none' }}
      />
      </div>

    {selectedChip === 0 && (
      <FormControl
        sx={{
          width: '200px',
          height: selectedAdvisors.length <=  2 ? '38px' : 'auto',
          borderRadius: '8px',
          border: '1px solid #EEEEEE',
          backgroundColor: '#fff',
          boxShadow: '0px 0px 10px 0px #0000000D',
          fontFamily: 'Inter, sans-serif',
          fontWeight: 600,
          fontSize: '14px',
          padding: '2px 8px',
          justifyContent: 'center',
          '.MuiInputBase-root': {
            minHeight: '38px',
            padding: 0,
            borderRadius: '8px',
            backgroundColor: 'transparent',
            border: 'none',
            boxShadow: 'none',
            alignItems: 'center',
          },
          '.MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
        }}
>
          <Select
            multiple
            displayEmpty
            value={selectedAdvisors}
            onChange={(e) =>
              setSelectedAdvisors(typeof e.target.value === 'string' ? e.target.value.split(',') : e.target.value)
            }
            renderValue={(selectedAdvisors) => {
              if (selectedAdvisors.length === 0) {
                return <span style={{ color: '#888' }}>Select Advisor</span>;
              }

              return (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                  {selectedAdvisors.map((value) => {
                    const advisor = advisors.find((a) => a.user_id === value);
                    return (
                      <Chip
                        key={value}
                        label={advisor?.first_name || value}
                        sx={{
                          backgroundColor: '#007BFF1A',
                          color: '#007BFF',
                          height: '24px',
                          fontSize: '12px',
                        }}
                      />
                    );
                  })}
                </Box>
              );
            }}
            
       
            inputProps={{
              'aria-label': 'Select Advisor',
            }}
          >
            {advisors.map((item) => (
              <MenuItem key={item.id} value={item.user_id}>
                {item.first_name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
    )}

    {selectedChip === 1 && (
      <FormControl
        sx={{
          width: '200px',
          height: selectedBranches.length <=  2 ? '38px' : 'auto',
          borderRadius: '8px',
          border: '1px solid #EEEEEE',
          backgroundColor: '#fff',
          boxShadow: '0px 0px 10px 0px #0000000D',
          fontFamily: 'Inter, sans-serif',
          fontWeight: 600,
          fontSize: '14px',
          padding: '2px 8px',
          justifyContent: 'center',
          '.MuiInputBase-root': {
            minHeight: '38px',
            padding: 0,
            borderRadius: '8px',
            backgroundColor: 'transparent',
            border: 'none',
            boxShadow: 'none',
            alignItems: 'center',
          },
          '.MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
        }}
>
          <Select
            multiple
            displayEmpty
            value={selectedBranches}
            onChange={(e) =>
              setSelectedBranches(typeof e.target.value === 'string' ? e.target.value.split(',') : e.target.value)
            }
            renderValue={(selectedBranches) => {
              if (selectedBranches.length === 0) {
                return <span style={{ color: '#888' }}>Select Branch</span>;
              }

              return (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                  {selectedBranches.map((value) => {
                    const branch = branches.find((a) => a.id === value);
                    return (
                      <Chip
                        key={value}
                        label={branch?.branch_name || value}
                        sx={{
                          backgroundColor: '#007BFF1A',
                          color: '#007BFF',
                          height: '24px',
                          fontSize: '12px',
                        }}
                      />
                    );
                  })}
                </Box>
              );
            }}
            
       
            inputProps={{
              'aria-label': 'Select Branch',
            }}
          >
            {branches.map((item) => (
              <MenuItem key={item.id} value={item.id}>
                {item.branch_name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
    )}

    {selectedChip === 2 && (
      <FormControl
        sx={{
          width: '200px',
          height: selectedProducts.length <=  2 ? '38px' : 'auto',
          borderRadius: '8px',
          border: '1px solid #EEEEEE',
          backgroundColor: '#fff',
          boxShadow: '0px 0px 10px 0px #0000000D',
          fontFamily: 'Inter, sans-serif',
          fontWeight: 600,
          fontSize: '14px',
          padding: '2px 8px',
          justifyContent: 'center',
          '.MuiInputBase-root': {
            minHeight: '38px',
            padding: 0,
            borderRadius: '8px',
            backgroundColor: 'transparent',
            border: 'none',
            boxShadow: 'none',
            alignItems: 'center',
          },
          '.MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
        }}
>
          <Select
            multiple
            displayEmpty
            value={selectedProducts}
            onChange={(e) =>
              setSelectedProducts(typeof e.target.value === 'string' ? e.target.value.split(',') : e.target.value)
            }
            renderValue={(selectedProducts) => {
              if (selectedProducts.length === 0) {
                return <span style={{ color: '#888' }}>Select Product</span>;
              }

              return (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                  {selectedProducts.map((value) => {
                    const product = products.find((a) => a.id === value);
                    return (
                      <Chip
                        key={value}
                        label={product?.name || value}
                        sx={{
                          backgroundColor: '#007BFF1A',
                          color: '#007BFF',
                          height: '24px',
                          fontSize: '12px',
                        }}
                      />
                    );
                  })}
                </Box>
              );
            }}
            
       
            inputProps={{
              'aria-label': 'Select Product',
            }}
          >
            {products.map((item) => (
              <MenuItem key={item.id} value={item.id}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
    )}
      
</div>
{/* Apply Button */}
  <button 
    style={{...applyButtonStyle, backgroundColor: allFiltersSelected ? '#007BFF' : '#007BFF80', cursor: allFiltersSelected ? 'pointer' : 'not-allowed' }} 
    disabled={!allFiltersSelected} 
    onClick={handleApplyFilter}
    >Apply</button>
</div>
)}



<div style={{ marginTop: '32px', overflowX: 'auto' }}>
  {selectedChip === 0 && (
    <AdvisorTable data={advisorData} />
  )}

  {selectedChip === 1 && (
    <BranchTable data={branchData} />
  )}

  {selectedChip === 2 && (
    <ProductTable data={productData} />
  )}
  
</div>
</div>

    <CustomSnackbar
            open={snackbarOpen}
            onClose={() => setSnackbarOpen(false)}
            message={snackbarMessage}
            severity={snackbarSeverity}
          />
    </div>
  );
}

export default DetailedRevenueReportPage;
